export const types = {
  INIT_TWO_FACTOR_AUTHENTICATION:
    'auth/twoFactorAuthentication/INIT_TWO_FACTOR_AUTHENTICATION',
  LOGIN_TWO_FACTOR_REQUEST:
    'auth/twoFactorAuthentication/LOGIN_TWO_FACTOR_REQUEST',
  LOGIN_TWO_FACTOR_SUCCESS:
    'auth/twoFactorAuthentication/LOGIN_TWO_FACTOR_SUCCESS',
  LOGIN_TWO_FACTOR_ERROR: 'auth/twoFactorAuthentication/LOGIN_TWO_FACTOR_ERROR',
};

export const twoFactorLogin = {
  request: ({ token }) => ({
    type: types.LOGIN_TWO_FACTOR_REQUEST,
    payload: { token },
  }),
  success: () => ({
    type: types.LOGIN_TWO_FACTOR_SUCCESS,
  }),
  error: ({ error }) => ({
    type: types.LOGIN_TWO_FACTOR_ERROR,
    payload: { error },
  }),
};

export const initTwoFactorAuthentication = ({
  username,
  password,
  next = '',
}) => ({
  type: types.INIT_TWO_FACTOR_AUTHENTICATION,
  payload: { username, password, next },
});
